import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { headingStyles } from '@helpers/typography';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.div `
  ${transition('opacity')};
  border-top: 2px solid ${brand.lightGrey};
  padding-top: 25px;
  position: relative;

  .noUi-handle[data-handle='0'] {
    display: none;
    pointer-events: none;
  }

  .noUi-handle[data-handle='1'] {
    display: none;
    pointer-events: none;
  }

  .noUi-connects {
    border-radius: 0;
  }

  .noUi-connect.c-1-color {
    background: #707070;
  }
  .noUi-connect.c-2-color {
    background: #ffdc00;
  }
  .noUi-connect.c-3-color {
    background: #bfbfbf;
  }
  .noUi-connect.c-4-color {
    background: blue;
  }
  .noUi-connect.c-5-color {
    background: purple;
  }

  .noUi-horizontal {
    height: 6px;
  }

  .noUi-horizontal .noUi-handle {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    background: #ffdc00;
    box-shadow: none;
    border: none;
    top: -12px;
    right: -14px;
  }

  .noUi-pips.noUi-pips-horizontal {
    top: 0%;
  }

  .noUi-value-horizontal {
    transform: translate(-50%, 50%);
  }

  .noUi-horizontal .noUi-handle:before {
    content: unset;
  }

  .noUi-horizontal .noUi-handle:after {
    content: unset;
  }

  .noUi-marker.noUi-marker-horizontal.noUi-marker-normal {
    width: 2px;
  }

  .noUi-marker.noUi-marker-horizontal.noUi-marker-large {
    background: ${brand.black};
    width: 2px;
    height: 12px;
  }

  .noUi-value.noUi-value-horizontal.noUi-value-large {
    color: ${brand.black};
    top: 18px;
    font-size: 18px;
    ${fonts.altGothicNo2.regular};
  }

  @media ${from(Device.TabletLarge)} {
    padding-top: 30px;
  }
`;
const SliderContainer = styled.div ``;
const FormLabel = styled.h2 `
  ${headingStyles}
  font-size: 20px;
`;
const SliderStyles = {
    Container,
    SliderContainer,
    FormLabel,
};
export default SliderStyles;
